const TRIAL_OFFER_OVERRIDES = {
  powerlifting_meet: "2026-06-19T23:59:59.999+02:00",
};
const DEFAULT_TRIAL_DAYS = 10;

export const isRecognizedTrialOfferCode = (trialOffer) => {
  if (!trialOffer) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(TRIAL_OFFER_OVERRIDES, trialOffer);
};

export const resolveTrialOfferOverride = (trialOffer) => {
  if (!isRecognizedTrialOfferCode(trialOffer)) {
    return null;
  }

  const trialOverrideIso = TRIAL_OFFER_OVERRIDES[trialOffer];
  const trialOverrideEndAt = new Date(trialOverrideIso);
  if (!Number.isFinite(trialOverrideEndAt.getTime())) {
    return null;
  }

  return {
    trialOfferCode: trialOffer,
    trialOverrideEndAt,
  };
};

export const resolveEffectiveTrialOfferOverride = ({
  trialOffer,
  trialStartDate,
  defaultTrialDays = DEFAULT_TRIAL_DAYS,
} = {}) => {
  const configuredOverride = resolveTrialOfferOverride(trialOffer);
  if (!configuredOverride) {
    return null;
  }

  const normalizedTrialStartDate =
    trialStartDate instanceof Date ? new Date(trialStartDate.getTime()) : new Date(trialStartDate);
  if (!Number.isFinite(normalizedTrialStartDate.getTime())) {
    return configuredOverride;
  }

  const defaultTrialEndAt = new Date(normalizedTrialStartDate.getTime());
  defaultTrialEndAt.setDate(defaultTrialEndAt.getDate() + defaultTrialDays);

  return {
    trialOfferCode: configuredOverride.trialOfferCode,
    trialOverrideEndAt:
      configuredOverride.trialOverrideEndAt.getTime() >= defaultTrialEndAt.getTime()
        ? configuredOverride.trialOverrideEndAt
        : defaultTrialEndAt,
  };
};
